const values = [
  {
    icon: 'ri-shield-check-line',
    title: 'Security First',
    desc: 'Every product is built with privacy and security as the foundation, not an afterthought.',
  },
  {
    icon: 'ri-code-s-slash-line',
    title: 'Expert Engineering',
    desc: 'Our team brings deep iOS expertise to deliver polished, high-performance applications.',
  },
  {
    icon: 'ri-user-heart-line',
    title: 'User-Centered Design',
    desc: 'We obsess over user experience, making complex technology feel simple and intuitive.',
  },
];

export default function AboutSection() {
  return (
    <section id="about" className="py-28" style={{ background: '#f9f8f6' }}>
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-20">
          <span
            className="inline-block text-xs font-semibold tracking-widest uppercase text-emerald-600 mb-4"
            style={{ fontFamily: "'Space Grotesk', sans-serif" }}
          >
            About Us
          </span>
          <h2
            className="text-4xl md:text-5xl font-bold text-gray-900 mb-5"
            style={{ fontFamily: "'Space Grotesk', sans-serif", letterSpacing: '-0.02em' }}
          >
            A Team Passionate
            <br />About iOS Innovation
          </h2>
          <p
            className="text-gray-500 text-lg max-w-2xl mx-auto leading-relaxed"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            Based in Tirane, Albania, ADDON SH.P.K. is a dedicated iOS development studio focused on building tools that genuinely improve people's digital lives.
          </p>
        </div>

        {/* Two-column layout */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-20">
          {/* Left: Image */}
          <div className="relative">
            <div className="rounded-3xl overflow-hidden" style={{ height: '520px' }}>
              <img
                src="https://public.readdy.ai/ai/img_res/e195367f98593f5fc337794f18278323.jpg"
                alt="ADDON SH.P.K. team workspace"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent rounded-3xl"></div>
            </div>
            {/* Overlay badge */}
            <div className="absolute bottom-6 left-6 bg-white/95 backdrop-blur-sm rounded-2xl px-5 py-4">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-emerald-100 rounded-xl">
                  <i className="ri-map-pin-line text-emerald-600 text-lg"></i>
                </div>
                <div>
                  <p className="text-xs text-gray-400 font-medium" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>Headquarters</p>
                  <p className="text-sm font-bold text-gray-900" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>Tirane, Albania</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right: Content */}
          <div>
            <p
              className="text-gray-600 text-lg leading-relaxed mb-8"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              We are a specialized iOS development company with a clear mission: to create applications that enhance security and performance for mobile users worldwide. Our team combines technical excellence with a deep understanding of what users truly need.
            </p>
            <p
              className="text-gray-600 text-lg leading-relaxed mb-10"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              From our studio in Tirane, we develop and maintain iOS products that are trusted by tens of thousands of users. We believe great software should be both powerful and effortless to use.
            </p>

            {/* Values */}
            <div className="flex flex-col gap-5">
              {values.map((v) => (
                <div key={v.title} className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-emerald-50 rounded-xl flex-shrink-0 mt-0.5">
                    <i className={`${v.icon} text-emerald-600 text-lg`}></i>
                  </div>
                  <div>
                    <h4
                      className="text-sm font-bold text-gray-900 mb-1"
                      style={{ fontFamily: "'Space Grotesk', sans-serif" }}
                    >
                      {v.title}
                    </h4>
                    <p
                      className="text-sm text-gray-500 leading-relaxed"
                      style={{ fontFamily: "'Inter', sans-serif" }}
                    >
                      {v.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>


      </div>
    </section>
  );
}
